const selectorsEl = {
  HEADER_SELECTOR: '.js-header',
  INDEX_HEADER_SELCTOR: '.js-height-header-sticky',
  MENU_BOTTOM_SELECTOR: '.js-menu-bottom',
  MENU_ANCHOR_STICKY_SELECTOR: '.js-menu-anchor-sticky',
  BUTTON_SEARCH_SELECTOR: '.js-button-search',
  SEARCH_INPUT_HEADER_SELECTOR: '.Search__Input',
  MENU_ITEMS_SELECTOR: '.js-menu-item',
  MENU_NAVIGATION_SELECTOR: 'menu-navigation',
  MENU_BOTTOM_STICKY_CLASS: 'menu-bottom--sticky',
  MENU_ACTIVE_CLASS: 'menu-active',
  MENU_HOVER_CLASS: 'is-hover-menu',
  MENU_OVERLAY_ACTIVE_CLASS: 'menu-overlay-active',
  THROTTLE_TIME: 100
}

const headerEl = document.querySelector(selectorsEl.HEADER_SELECTOR)
const indexHeaderEl = document.querySelector(selectorsEl.INDEX_HEADER_SELCTOR)
const menuItemsEls = document.querySelectorAll(selectorsEl.MENU_ITEMS_SELECTOR)
const menuBottomEl = document.querySelector(selectorsEl.MENU_BOTTOM_SELECTOR)
const searchBtnEls = document.querySelectorAll(selectorsEl.BUTTON_SEARCH_SELECTOR)
const menuListBottomEl = document.querySelector('.js-mega-menu-list-bottom')
const menuListTopEl = document.querySelector('.js-mega-menu-list-top')
const headerOptions = headerEl ? JSON.parse(headerEl.getAttribute('data-section-settings')) : undefined
const isHeaderSticky = headerOptions ? headerOptions.isSticky : false
const menuAnchorSticky = document.querySelector(selectorsEl.MENU_ANCHOR_STICKY_SELECTOR)
let topOffsetMenuBottom = menuBottomEl ? Math.abs(window.innerHeight - menuBottomEl.clientHeight) : indexHeaderEl ? Math.abs(window.innerHeight - indexHeaderEl.clientHeight) : 0
const topOffsetMenuBottomScroll = topOffsetMenuBottom + 10

const showHeaderFixed = () => {
  if (topOffsetMenuBottom > 0) {
    const buffer = 24 // Add buffer to prevent flickering
    if (window.scrollY > topOffsetMenuBottom + buffer) {
      headerEl && headerEl.classList.add('is-active')
      menuBottomEl && menuBottomEl.classList.add('header-active')
    } else if (window.scrollY < topOffsetMenuBottom - buffer) {
      headerEl && headerEl.classList.remove('is-active')
      menuBottomEl && menuBottomEl.classList.remove('header-active')
    }
  }

  let headerHeight = Math.floor(headerEl.getBoundingClientRect().height)

  if (headerEl.classList.contains('is-active')) {
    headerHeight += Math.floor(menuAnchorSticky.getBoundingClientRect().height)
  }

  document.documentElement.style.setProperty('--header-height', headerHeight + 'px')
}

const scrollHeader = () => {
  if (menuListBottomEl && menuListBottomEl.children.length > 0) {
    for (let i = 0; i < menuListBottomEl.children.length; i++) {
      menuListBottomEl.children[i].addEventListener('click', (e) => {
        if (menuListTopEl?.children[i].hasAttribute('data-dropdown')) {
          e.preventDefault()
          document.scrollingElement?.scrollTo({
            top: topOffsetMenuBottomScroll,
            behavior: 'smooth'
          })
          Array.from(menuListTopEl?.children).forEach((element) => {
            if (element.classList.contains(selectorsEl.MENU_ACTIVE_CLASS)) {
              element.classList.remove(selectorsEl.MENU_ACTIVE_CLASS)
            }
          })
          menuListTopEl?.children[i].classList.add(selectorsEl.MENU_ACTIVE_CLASS)
          headerEl && headerEl.classList.add(selectorsEl.MENU_HOVER_CLASS)
        }
      })
    }
  }
}

const appendMenuAnchor = () => {
  if (headerEl && menuAnchorSticky) {
    headerEl.appendChild(menuAnchorSticky)
    document.documentElement.style.setProperty('--header-sticky-height', headerEl.clientHeight + 'px')
    headerEl.classList.remove('animation-fade-out')
    headerEl.classList.add('animation-fade-in')
  }
}

const throttle = (mainFunction, delay) => {
  let timerFlag = null

  return (...args) => {
    if (timerFlag === null) {
      mainFunction(...args)
      timerFlag = setTimeout(() => {
        timerFlag = null
      }, delay)
    }
  }
}

const debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

// This function automatically focuses the search input header
if (searchBtnEls.length > 0) {
  const menuSlideout = document.querySelector('menu-slideout')
  searchBtnEls.forEach((searchBtnEl) => {
    searchBtnEl.addEventListener('click', () => {
      if (menuSlideout) {
        menuSlideout.classList.contains('is-active') && menuSlideout.closeMenuFunc()
        bodyScrollLock.clearAllBodyScrollLocks()
      }
      document.querySelector(selectorsEl.SEARCH_INPUT_HEADER_SELECTOR)?.focus()
      window.openDrawer()
    })
  })
}

if (isHeaderSticky && menuBottomEl) {
  menuBottomEl.classList.add(selectorsEl.MENU_BOTTOM_STICKY_CLASS)
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.theme.pageType.includes('page') || window.theme.pageType === 'blog') {
    appendMenuAnchor()
  }

  if (window.theme.pageType === 'index' || window.theme.templatePage.includes('stores-landing') || window.theme.pageType === 'blog') {
    showHeaderFixed()
    scrollHeader()
  }
})

if (window.theme.pageType === 'index' || window.theme.pageType.includes('page') || window.theme.pageType === 'blog') {
  window.addEventListener(
    'scroll',
    throttle(() => {
      showHeaderFixed()
    }),
    selectorsEl.THROTTLE_TIME
  )
}

if (menuItemsEls.length > 0) {
  menuItemsEls.forEach((menuItem) => {
    const menuNavigationEl = menuItem ? menuItem.closest(selectorsEl.MENU_NAVIGATION_SELECTOR) : undefined

    menuItem.addEventListener(
      'mouseover',
      debounce(() => {
        const hasDropdownMenu = menuNavigationEl ? menuItem.hasAttribute('data-dropdown') : false

        if (hasDropdownMenu) {
          menuNavigationEl && menuNavigationEl.classList.add(selectorsEl.MENU_OVERLAY_ACTIVE_CLASS)
        } else {
          menuNavigationEl && menuNavigationEl.classList.remove(selectorsEl.MENU_OVERLAY_ACTIVE_CLASS)
        }

        if (menuItem && !menuItem.classList.contains(selectorsEl.MENU_ACTIVE_CLASS)) {  
          menuItem.classList.add(selectorsEl.MENU_ACTIVE_CLASS)
        }

        headerEl && headerEl.classList.add(selectorsEl.MENU_HOVER_CLASS)
      }, 0)
    )

    menuItem.addEventListener(
      'mouseleave',
      debounce(() => {
        menuNavigationEl && menuNavigationEl.classList.remove(selectorsEl.MENU_OVERLAY_ACTIVE_CLASS) 
        headerEl && headerEl.classList.remove(selectorsEl.MENU_HOVER_CLASS)
        menuItem && menuItem.classList.remove(selectorsEl.MENU_ACTIVE_CLASS)
      }, 0)
    )
  })
}

if (!customElements.get('menu-navigation')) {
  const DELAY = 0
  const selectors = {
    MEGA_MENU_MAIN_SELECTOR: '.js-mega-menu-main',
    MEGA_MENU_MAIN_INNER_SELECTOR: '.js-mega-menu-main-inner',
    MEGA_MENU_OVERLAY_SELECTOR: '.js-mega-menu-overlay',
    MEGA_MENU_MAIN_SUBMENU_SELECTOR: '.js-mega-menu-main-submenu',
    SUB_MAIN_MENU_WRAPPER_SELECTOR: '.js-sub-main-menu-wrapper',
    SUB_MAIN_MENU_ITEM_SELECTOR: '.js-sub-main-menu-item',
    MENU_ITEMS_SELECTOR: '.js-menu-item',
    MEGA_MENU_LINK_SELECTOR: '.js-mega-menu-main a',
    HOVER_CLASS: 'hover',
    HIDDEN_CLASS: 'hidden',
    SHOW_CLASS: 'show',
    ACTIVE_CLASS: 'active',
    MENU_OVERLAY_ACTIVE_CLASS: 'menu-overlay-active',
    MENU_ACTIVE_CLASS: 'menu-active',
    MENU_SUB_ACTIVE_CLASS: 'is-sub-menu-active'
  }

  class MenuNavigation extends HTMLElement {
    constructor() {
      super()
      this.megaMenuMainEls = Array.from(this.querySelectorAll(selectors.MEGA_MENU_MAIN_SELECTOR))
      this.megaMenuLinkEls = Array.from(this.querySelectorAll(selectors.MEGA_MENU_LINK_SELECTOR))
      this.megaMenuMainInnerEls = Array.from(this.querySelectorAll(selectors.MEGA_MENU_MAIN_INNER_SELECTOR))
      this.menuItemEls = this.querySelectorAll(selectors.MENU_ITEMS_SELECTOR)
      this.megaMenuOverlayEl = this.querySelector(selectors.MEGA_MENU_OVERLAY_SELECTOR)

      this.attachEvents()
    }

    attachEvents() {
      if (this.megaMenuMainInnerEls && this.megaMenuMainInnerEls.length > 0) {
        this.megaMenuMainInnerEls.forEach((navItem) => {
          const subMenuNavigationEls = navItem.querySelectorAll(selectors.MEGA_MENU_MAIN_SUBMENU_SELECTOR)
          const subMenuWrapperEl = navItem.querySelector(selectors.SUB_MAIN_MENU_WRAPPER_SELECTOR)
          const subMenuItemEls = navItem.querySelectorAll(selectors.SUB_MAIN_MENU_ITEM_SELECTOR)

          navItem.addEventListener(
            'mouseover',
            debounce(() => {
              navItem.classList.add(selectors.ACTIVE_CLASS)
              this.megaMenuMainInnerEls.map(bodyScrollLock.disableBodyScroll)
            }, DELAY)
          )

          navItem.addEventListener(
            'mouseleave',
            debounce(() => {
              navItem.classList.remove(selectors.ACTIVE_CLASS)
              bodyScrollLock.clearAllBodyScrollLocks()
              subMenuItemEls.forEach((link) => {
                if (link.classList.contains(selectors.SHOW_CLASS)) {
                  link.classList.remove(selectors.SHOW_CLASS)
                }
              })
              subMenuWrapperEl.children[0].classList.add(selectors.SHOW_CLASS)
              subMenuNavigationEls.forEach((subNav) => {
                Array.from(subNav?.children).forEach((link) => {
                  if (link.children[0].classList.contains(selectors.HOVER_CLASS)) {
                    link.children[0].classList.remove(selectors.HOVER_CLASS)
                  }
                })
                subNav.children[0].children[0].classList.add(selectors.HOVER_CLASS)
              })
            }, DELAY)
          )

          if (menuListTopEl && menuListTopEl.children.length > 0) {
            for (let i = 0; i < menuListTopEl.children.length; i++) {
              menuListTopEl.children[i].addEventListener('mouseover', (e) => {
                Array.from(menuListTopEl.children).forEach((element) => {
                  if (element.classList.contains('active')) {
                    element.classList.remove('active')
                  }
                })
                if (headerEl?.classList.contains('is-active')) {
                  menuListTopEl.children[i].classList.add(selectors.MENU_ACTIVE_CLASS)
                }
                this.megaMenuMainInnerEls.map(bodyScrollLock.disableBodyScroll)
              })

              menuListTopEl.children[i].addEventListener('mouseleave', (e) => {
                menuListTopEl.children[i].classList.remove(selectors.MENU_ACTIVE_CLASS)
                bodyScrollLock.clearAllBodyScrollLocks()
              })
            }
          }

          if (subMenuNavigationEls && subMenuNavigationEls.length > 0) {
            subMenuNavigationEls.forEach((item) => {
              for (let i = 0; i < item.children.length; i++) {
                item.children[i].children[0].addEventListener(
                  'click',
                  debounce((e) => {
                    e.preventDefault()
                    Array.from(item?.children).forEach((link) => {
                      if (link.children[0].classList.contains(selectors.HOVER_CLASS)) {
                        link.children[0].classList.remove(selectors.HOVER_CLASS)
                      }
                    })
                    subMenuItemEls.forEach((link) => {
                      if (link.classList.contains(selectors.SHOW_CLASS)) {
                        link.classList.remove(selectors.SHOW_CLASS)
                      }
                    })


                    if (item.children[i].hasAttribute('data-dropdown')) {
                      if (this.megaMenuMainEls.length > 0) {
                        this.megaMenuMainEls.forEach((item) => {
                          item.classList.add(selectors.MENU_SUB_ACTIVE_CLASS)
                        })
                      }
                      item.children[i].children[0].classList.add(selectors.HOVER_CLASS)
                      subMenuWrapperEl.children[i].classList.add(selectors.SHOW_CLASS)
                    }
                  }, DELAY)
                )
              }
            })
          }
        })
      }

      if (this.megaMenuOverlayEl) {
        this.megaMenuOverlayEl.addEventListener(
          'mouseover',
          debounce(() => {
            this.classList.remove(selectors.MENU_OVERLAY_ACTIVE_CLASS)
          }, DELAY)
        )
      }

      if (this.megaMenuLinkEls && this.megaMenuLinkEls.length > 0) {
        this.megaMenuLinkEls.forEach((link) => {
          link.addEventListener('click', function (event) {
            const href = event.target.getAttribute('href')
            if (href === '#') {
              event.preventDefault()
            }

            if (href.includes('#') && href !== '#') {
              document.querySelector(selectorsEl.HEADER_SELECTOR)?.classList.remove(selectorsEl.MENU_HOVER_CLASS)
              document.querySelectorAll(selectors.MENU_ITEMS_SELECTOR).forEach(item => {
                item.classList.remove(selectors.MENU_ACTIVE_CLASS)
              })
              this.classList.remove(selectors.MENU_OVERLAY_ACTIVE_CLASS)
              const menuNavigation = this.closest('menu-navigation')
              menuNavigation?.classList.remove(selectors.MENU_OVERLAY_ACTIVE_CLASS)
              bodyScrollLock.clearAllBodyScrollLocks()

              const targetSelector = href.split('#')[1];
              const targetElement = document.querySelector(`.${targetSelector}`)
              const scrollOffset = targetElement.offsetTop - 50;

              if (targetElement) {
                window.scrollTo({
                  top: scrollOffset,
                  behavior: 'smooth'
                })
              }
            }
          })
        })
      }
    }
  }

  customElements.define('menu-navigation', MenuNavigation)
}
